module.exports = __webpack_public_path__ + "static/hero-brand-logos-rev-255df974301c5a4c45d47ee301b21e89.png";